"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatRoomConfig = void 0;
const core_1 = require("@hyper-hyper-space/core");
class ChatRoomConfig extends core_1.HashedObject {
    constructor(chatRoomWordCode, chatRoomWordCodeLang = 'en') {
        super();
        if (chatRoomWordCode !== undefined) {
            this.chatRoomWordCode = chatRoomWordCode;
            this.chatRoomWordCodeLang = chatRoomWordCodeLang;
            this.setId(this.computeId());
            this.addDerivedField('authorIdentity', new core_1.MutableReference());
            this.addDerivedField('archiveLocally', new core_1.MutableReference());
        }
    }
    getClassName() {
        return ChatRoomConfig.className;
    }
    init() {
    }
    async validate(_references) {
        return this.chatRoomWordCode !== undefined &&
            this.chatRoomWordCodeLang !== undefined &&
            this.getId() === this.computeId() &&
            this.checkDerivedField('authorIdentity') &&
            this.authorIdentity instanceof core_1.MutableReference &&
            this.checkDerivedField('archiveLocally') &&
            this.archiveLocally instanceof core_1.MutableReference;
    }
    computeId() {
        return core_1.Hashing.forString(this.chatRoomWordCodeLang + '/' + this.chatRoomWordCode.join('-'));
    }
}
exports.ChatRoomConfig = ChatRoomConfig;
ChatRoomConfig.className = 'p2p-chat/v0/model/ChatRoomConfig';
core_1.HashedObject.registerClass(ChatRoomConfig.className, ChatRoomConfig);
//# sourceMappingURL=ChatRoomConfig.js.map